import { Icon } from 'components';
import { Roles } from 'configs/roles';
// import { MainLayout } from 'layouts';
import MainLayout from 'layouts/Main';
import React, { lazy } from 'react';

import { MainRouteKeys } from '../enums';
import { MainRouteObject } from '../types';
import AuditLogsAdminPage from 'pages/audit-logs-admin';
import { Actions } from 'configs/actions';
const BalanceTransferToBankByBIDVPage = lazy(
  () => import('pages/Personal/Balance/TransferToBankByBIDV'),
);

const UsersPage = lazy(() => import('pages/Users'));
// const TransferPage = lazy(() => import('pages/transfers'));
const PersonalPage = lazy(() => import('pages/Personal'));
const PersonalInfoPage = lazy(() => import('pages/Personal/Info'));
const PersonalFinancialLimitsPage = lazy(
  () => import('pages/Personal/FinancialLimits'),
);
const PersonalTwoFaSecurityPage = lazy(
  () => import('pages/Personal/TwoFaSecurity'),
);
const PersonalChangePasswordPage = lazy(
  () => import('pages/Personal/ChangePassword'),
);
const PersonalBalancePage = lazy(() => import('pages/Personal/Balance'));
const BalanceManagementPage = lazy(
  () => import('pages/Personal/Balance/Manage'),
);
const PersonalReward = lazy(() => import('pages/Personal/BalanceReward'));
const PersonalRewardPage = lazy(
  () => import('pages/Personal/BalanceReward/PersonalRewardManage'),
);
const BalanceTransferPage = lazy(
  () => import('pages/Personal/Balance/Transfer'),
);
const PersonalLogoutPage = lazy(() => import('pages/Personal/Logout'));
const PayBillPage = lazy(() => import('pages/PayBill'));
const PayBillElectricPage = lazy(() => import('pages/PayBill/Electric/List'));
const PayBillElectricDetailsPage = lazy(
  () => import('pages/PayBill/Electric/Details'),
);
const TransactionsPage = lazy(() => import('pages/Transactions'));
const TransactionOrdersPage = lazy(
  () => import('pages/Transactions/Orders/List'),
);
const TransactionOrderDetailsPage = lazy(
  () => import('pages/Transactions/Orders/Details'),
);
const TopUpPointsPage = lazy(() => import('pages/Personal/Balance/Topup'));
const UpdateUser = lazy(() => import('pages/update-user'));
const CustomersPage = lazy(() => import('pages/customers'));
const PointTransactionsPage = lazy(() => import('pages/point-transactions'));
const PointTransactionDetailsPage = lazy(
  () => import('pages/point-transactions/details'),
);
const PointRewardTransactionsList = lazy(
  () => import('pages/point-reward-transactions'),
);
const OrdersPage = lazy(() => import('pages/orders'));
const TransactionIDBanksPage = lazy(() => import('pages/TransactionsBank'));
const AccountTPBankPage = lazy(() => import('pages/accountTPBank'));
const BankManagementPage = lazy(
  () => import('pages/request-withdraw/BankManagement'),
);
const RequestWithdrawOwnPage = lazy(
  () => import('pages/request-withdraw/request-withdraw-own'),
);
const RequestWithdrawOwnDetailPage = lazy(
  () => import('pages/request-withdraw/request-withdraw-own-detail'),
);
const CreateRequestWithdrawPage = lazy(
  () => import('pages/request-withdraw/create-request-withdraw'),
);
const CheckRequestWithdrawPage = lazy(
  () => import('pages/request-withdraw/check-request-withdraw'),
);
const CheckRequestWithdrawDetailPage = lazy(
  () => import('pages/request-withdraw/check-request-withdraw-detail'),
);
const RequestWithdrawPage = lazy(() => import('pages/request-withdraw'));
const CompanyDepartmentPage = lazy(() => import('pages/company-department'));
const CompanyListPage = lazy(() => import('pages/company-department/company'));
const RefferalPage = lazy(() => import('pages/refferal'));
const RefferalDetailPage = lazy(() => import('pages/refferal/manage'));
const RefferalTransactionManagePage = lazy(
  () => import('pages/refferal/transaction'),
);
const WithdrawToMoraPay = lazy(
  () => import('pages/Personal/BalanceReward/WithdrawToMoraPay'),
);
const DepositFromMoraPay = lazy(
  () => import('pages/Personal/BalanceReward/DepositFromMoraPay'),
);

const EnergyDepartmentPage = lazy(() => import('pages/energy-department'));
const BranchEnergyPage = lazy(() => import('pages/energy-department/oil-type'));
const SupplierEnergyPage = lazy(
  () => import('pages/energy-department/supplier'),
);
const GasStationPage = lazy(() => import('pages/energy-department/oil-store'));
const TransactionsEnergyListPage = lazy(
  () => import('pages/energy-department/transactions'),
);
const BidvVirtualAccountPage = lazy(() => import('pages/bidv-virtual-account'));
const BidvVirtualAccountInquiryPage = lazy(
  () => import('pages/bidv-virtual-account/inquiry'),
);
const BidvBankTransferPage = lazy(() => import('pages/bidv-bank-transfer'));
const BidvBankTransferReconciliationPage = lazy(
  () => import('pages/bidv-bank-transfer/reconciliation'),
);
const BidvTransHistoryPage = lazy(
  () => import('pages/bidv-bank-transfer/trans-history'),
);
const BidvBankTransferWhitelistPage = lazy(
  () => import('pages/bidv-bank-transfer/whitelist'),
);
const BidvTransferDestWhitelistPage = lazy(
  () => import('pages/bidv-bank-transfer/dest-whitelist'),
);
const BidvTransferWithEvidencePage = lazy(
  () => import('pages/bidv-transfer-with-evidence'),
);
const BidvTransferWithEvidenceCreatePage = lazy(
  () => import('pages/bidv-transfer-with-evidence/create'),
);
const BidvTransferWithEvidenceOwnPage = lazy(
  () => import('pages/bidv-transfer-with-evidence/own'),
);
const BidvTransferWithEvidenceAllPage = lazy(
  () => import('pages/bidv-transfer-with-evidence/all'),
);
const BidvTransferWithEvidenceDetailsPage = lazy(
  () => import('pages/bidv-transfer-with-evidence/details'),
);
const SettingsPage = lazy(() => import('pages/settings'));
const AppVersionConfigPage = lazy(() => import('pages/settings/app-version'));
const UnlockSmsRateLimitPage = lazy(
  () => import('pages/settings/unlock-sms-rate-limit'),
);
const BalanceOperationControlsPage = lazy(
  () => import('pages/settings/balance-operation-controls'),
);

export const MainRoutesConfig = {
  [MainRouteKeys.Root]: {
    path: MainRouteKeys.Root,
    name: 'Trang chủ',
    title: 'Trang chủ',
    element: <MainLayout />,
    redirectUrl: MainRouteKeys.Personal,
    icon: <Icon.User />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.Personal]: {
    path: MainRouteKeys.Personal,
    name: 'Tài khoản',
    title: 'Tài khoản',
    element: <PersonalPage />,
    redirectUrl: MainRouteKeys.PersonalInfo,
    icon: <Icon.Profile />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalInfo]: {
    path: MainRouteKeys.PersonalInfo,
    name: 'Xem thông tin',
    title: 'Xem thông tin ',
    element: <PersonalInfoPage />,
    icon: <Icon.Profile />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalFinancialLimits]: {
    path: MainRouteKeys.PersonalFinancialLimits,
    name: 'Quản lý hạn mức',
    title: 'Quản lý hạn mức',
    element: <PersonalFinancialLimitsPage />,
    icon: <Icon.CreditCard />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalTwoFaSecurity]: {
    path: MainRouteKeys.PersonalTwoFaSecurity,
    name: 'Bảo mật 2FA',
    title: 'Bảo mật 2FA',
    element: <PersonalTwoFaSecurityPage />,
    icon: <Icon.Lock />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalChangePassword]: {
    path: MainRouteKeys.PersonalChangePassword,
    name: 'Thay đổi mật khẩu',
    title: 'Thay đổi mật khẩu ',
    element: <PersonalChangePasswordPage />,
    icon: <Icon.ChangePasswordIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalBalance]: {
    path: MainRouteKeys.PersonalBalance,
    name: 'Quản lý số dư',
    title: 'Quản lý số dư ',
    element: <PersonalBalancePage />,
    redirectUrl: MainRouteKeys.Balance,
    icon: <Icon.Wallet />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalReward]: {
    path: MainRouteKeys.PersonalReward,
    name: 'Điểm thưởng',
    title: 'Điểm thưởng',
    element: <PersonalReward />,
    redirectUrl: MainRouteKeys.PersonalRewardManage,
    icon: <Icon.Wallet />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalRewardManage]: {
    path: MainRouteKeys.PersonalRewardManage,
    name: 'Quản lý điểm thưởng',
    title: 'Quản lý điểm thưởng',
    element: <PersonalRewardPage />,
    icon: <Icon.Wallet />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.DepositFromMoraPay]: {
    path: MainRouteKeys.DepositFromMoraPay,
    name: 'Nạp điểm từ Mora Pay',
    title: 'Nạp điểm từ Mora Pay',
    element: <DepositFromMoraPay />,
    icon: <Icon.Exchange />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.WithdrawToMoraPay]: {
    path: MainRouteKeys.WithdrawToMoraPay,
    name: 'Rút điểm thưởng ra Mora Pay',
    title: 'Rút điểm thưởng ra Mora Pay',
    element: <WithdrawToMoraPay />,
    icon: <Icon.CoinExchange />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.BankManagement]: {
    path: MainRouteKeys.BankManagement,
    name: 'Quản lý Ngân hàng',
    title: 'Quản lý Ngân hàng',
    element: <BankManagementPage />,
    icon: <Icon.BankBuilding />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalLogout]: {
    path: MainRouteKeys.PersonalLogout,
    name: 'Đăng xuất',
    title: 'Đăng xuất ',
    element: <PersonalLogoutPage />,
    icon: <Icon.Logout />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.RequestWithdraw]: {
    path: MainRouteKeys.RequestWithdraw,
    name: 'Rút điểm',
    title: 'Yêu cầu rút điểm',
    element: <RequestWithdrawPage />,
    redirectUrl: MainRouteKeys.CreateRequestWithdraw,
    icon: <Icon.Withdraw />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.CreateRequestWithdraw]: {
    path: MainRouteKeys.CreateRequestWithdraw,
    name: 'Tạo yêu cầu rút điểm',
    title: 'Tạo yêu cầu rút điểm',
    element: <CreateRequestWithdrawPage />,
    icon: <Icon.WithdrawRequest />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.RequestWithdrawOwn]: {
    path: MainRouteKeys.RequestWithdrawOwn,
    name: 'Quản lý Y/C rút điểm',
    title: 'Quản lý Y/C rút điểm',
    element: <RequestWithdrawOwnPage />,
    icon: <Icon.ManageList />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.RequestWithdrawOwnDetail]: {
    path: MainRouteKeys.RequestWithdrawOwnDetail,
    name: 'Chi tiết Y/C rút điểm',
    title: 'Chi tiết Y/C rút điểm',
    element: <RequestWithdrawOwnDetailPage />,
    icon: <Icon.ViewDetailIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.CheckRequestWithdrawList]: {
    path: MainRouteKeys.CheckRequestWithdrawList,
    name: 'Duyệt Y/C rút điểm',
    title: 'Duyệt Y/C rút điểm',
    element: <CheckRequestWithdrawPage />,
    icon: <Icon.ConfirmStatus />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: Actions.WithdrawPoint_ListRequest,
  },
  [MainRouteKeys.CheckRequestWithdrawDetail]: {
    path: MainRouteKeys.CheckRequestWithdrawDetail,
    name: 'Chi tiết Y/C rút điểm',
    title: 'Chi tiết Y/C rút điểm',
    element: <CheckRequestWithdrawDetailPage />,
    icon: <Icon.ViewDetailIcon />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: Actions.WithdrawPoint_ListRequest,
  },
  [MainRouteKeys.CompanyDepartment]: {
    path: MainRouteKeys.CompanyDepartment,
    name: 'Quản lý Doanh nghiệp/HTX',
    title: 'Quản lý Doanh nghiệp/HTX',
    element: <CompanyDepartmentPage />,
    redirectUrl: MainRouteKeys.Company,
    icon: <Icon.Cooperative />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: Actions.ManageCompany_ListCompany,
  },
  [MainRouteKeys.Company]: {
    path: MainRouteKeys.Company,
    name: 'Quản lý Doanh nghiệp/HTX',
    title: 'Quản lý Doanh nghiệp/HTX',
    element: <CompanyListPage />,
    icon: <Icon.Cooperative />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: Actions.ManageCompany_ListCompany,
  },
  [MainRouteKeys.Users]: {
    path: MainRouteKeys.Users,
    name: 'Quản lý người dùng',
    title: 'Quản lý người dùng',
    element: <UsersPage />,
    icon: <Icon.User />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR, Roles.MC],
    screenAction: Actions.ManageUser_ListUser,
  },
  [MainRouteKeys.UpdateUser]: {
    path: MainRouteKeys.UpdateUser,
    name: 'Cập nhật người dùng',
    title: 'Cập nhật người dùng',
    element: <UpdateUser />,
    icon: <Icon.User />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: '',
  },
  [MainRouteKeys.Balance]: {
    path: MainRouteKeys.Balance,
    name: 'Quản lý số dư',
    title: 'Quản lý số dư',
    element: <PersonalBalancePage />,
    redirectUrl: MainRouteKeys.BalanceManage,
    icon: <Icon.Wallet />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.BalanceManage]: {
    path: MainRouteKeys.BalanceManage,
    name: 'Quản lý số dư',
    title: 'Quản lý số dư',
    element: <BalanceManagementPage />,
    icon: <Icon.CoinExchange />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.Transfers]: {
    path: MainRouteKeys.Transfers,
    name: 'Chuyển điểm',
    title: 'Chuyển điểm',
    element: <BalanceTransferPage />,
    icon: <Icon.BalanceIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.TopUp]: {
    path: MainRouteKeys.TopUp,
    name: 'Nạp điểm',
    title: 'Nạp điểm',
    element: <TopUpPointsPage />,
    icon: <Icon.BalanceIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.TransfersToBankBIDV]: {
    path: MainRouteKeys.TransfersToBankBIDV,
    name: 'Chuyển điểm ra Ngân hàng BIDV',
    title: 'Chuyển điểm ra Ngân hàng BIDV',
    element: <BalanceTransferToBankByBIDVPage />,
    icon: <Icon.BalanceIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PayBill]: {
    path: MainRouteKeys.PayBill,
    name: 'Thanh toán hóa đơn',
    title: 'Thanh toán hóa đơn',
    element: <PayBillPage />,
    redirectUrl: MainRouteKeys.PayBillElectric,
    icon: <Icon.BalanceIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PayBillElectric]: {
    path: `${MainRouteKeys.PayBillElectric}`,
    name: 'Hoá đơn điện',
    title: 'Hoá đơn điện',
    element: <PayBillElectricPage />,
    icon: <Icon.User />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PayBillElectricDetails]: {
    path: MainRouteKeys.PayBillElectricDetails,
    name: 'Thông tin đơn hàng',
    title: 'Thông tin đơn hàng',
    element: <PayBillElectricDetailsPage />,
    icon: <Icon.User />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.Transactions]: {
    path: MainRouteKeys.Transactions,
    name: 'Quản lý giao dịch',
    title: 'Quản lý giao dịch',
    element: <TransactionsPage />,
    redirectUrl: MainRouteKeys.PointTransactions,
    icon: <Icon.TransactionIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.TransactionBills]: {
    path: MainRouteKeys.TransactionBills,
    name: 'Thanh toán hóa đơn',
    title: 'Thanh toán hóa đơn',
    element: <TransactionOrdersPage />,
    icon: <Icon.User />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.TransactionBillDetails]: {
    path: MainRouteKeys.TransactionBillDetails,
    name: 'Thông tin đơn hàng',
    title: 'Thông tin đơn hàng',
    element: <TransactionOrderDetailsPage />,
    icon: <Icon.User />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.Customers]: {
    path: MainRouteKeys.Customers,
    name: 'Quản lý khách hàng',
    title: 'Quản lý khách hàng',
    element: <CustomersPage />,
    icon: <Icon.Account />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: '',
  },
  [MainRouteKeys.PointTransactions]: {
    path: MainRouteKeys.PointTransactions,
    name: 'Cộng/trừ điểm',
    title: 'Cộng/trừ điểm',
    element: <PointTransactionsPage />,
    icon: <Icon.PointTransaction />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PointTransactionDetails]: {
    path: MainRouteKeys.PointTransactionDetails,
    name: 'Chi tiết giao dịch',
    title: 'Chi tiết giao dịch',
    element: <PointTransactionDetailsPage />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PointRewardTransactions]: {
    path: MainRouteKeys.PointRewardTransactions,
    name: 'Điểm thưởng',
    title: 'Điểm thưởng',
    element: <PointRewardTransactionsList />,
    icon: <Icon.Gift />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.Orders]: {
    path: MainRouteKeys.Orders,
    name: 'Quản lý đơn hàng',
    title: 'Quản lý đơn hàng',
    element: <OrdersPage />,
    icon: <Icon.Account />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.TPBank]: {
    path: MainRouteKeys.TPBank,
    name: 'Ngân hàng TPBank',
    title: 'Ngân hàng TPBank',
    element: <AccountTPBankPage />,
    redirectUrl: MainRouteKeys.AccountBank,
    icon: <Icon.BankBuilding />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: [
      Actions.TPBank_InqueryTransaction,
      Actions.TPBank_ResendTransaction,
    ],
  },
  [MainRouteKeys.AccountBank]: {
    path: MainRouteKeys.AccountBank,
    name: 'Truy vấn tiểu khoản',
    title: 'Truy vấn tiểu khoản',
    element: <AccountTPBankPage />,
    icon: <Icon.Search />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: Actions.TPBank_InqueryTransaction,
  },
  [MainRouteKeys.TransactionsBank]: {
    path: MainRouteKeys.TransactionsBank,
    name: 'Gửi lại giao dịch',
    title: 'Gửi lại giao dịch',
    element: <TransactionIDBanksPage />,
    icon: <Icon.Reload />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: Actions.TPBank_ResendTransaction,
  },
  [MainRouteKeys.Refferal]: {
    path: MainRouteKeys.Refferal,
    name: 'Sự kiện Giới thiệu',
    title: 'Sự kiện Giới thiệu',
    element: <RefferalPage />,
    redirectUrl: MainRouteKeys.RefferalDetail,
    icon: <Icon.Affiliate />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: [
      Actions.ManageReferralEvent_ViewEvent,
      Actions.ManageReferralEvent_ListTransaction,
    ],
  },
  [MainRouteKeys.RefferalDetail]: {
    path: MainRouteKeys.RefferalDetail,
    name: 'Chi tiết sự kiện',
    title: 'Chi tiết sự kiện',
    element: <RefferalDetailPage />,
    icon: <Icon.Star />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: Actions.ManageReferralEvent_ViewEvent,
  },
  [MainRouteKeys.RefferalDetailHistory]: {
    path: MainRouteKeys.RefferalDetailHistory,
    name: 'Lịch sử giao dịch',
    title: 'Lịch sử giao dịch',
    element: <RefferalTransactionManagePage />,
    icon: <Icon.HistoryIcon />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: Actions.ManageReferralEvent_ListTransaction,
  },
  [MainRouteKeys.AuditLogsAdmin]: {
    path: MainRouteKeys.AuditLogsAdmin,
    name: 'Logs Admin',
    title: 'Logs Admin',
    element: <AuditLogsAdminPage />,
    icon: <Icon.Data />,
    roles: [Roles.SUPER_ADMIN],
    screenAction: '',
  },
  // Energy Department Routes
  [MainRouteKeys.EnergyDepartment]: {
    path: MainRouteKeys.EnergyDepartment,
    name: 'Q.Lý Dịch vụ',
    title: 'Q.Lý Dịch vụ',
    element: <EnergyDepartmentPage />,
    redirectUrl: MainRouteKeys.TransactionEnergy,
    icon: <Icon.SupplierIcon />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.OIL_MC],
    screenAction: [
      Actions.ManageOilMerchant_ListOilStoreType,
      Actions.ManageOilMerchant_ListOilSupplier,
      Actions.ManageOilMerchant_ListOilStore,
      Actions.ManageOilMerchant_GetOilStoreTransaction,
    ],
  },
  [MainRouteKeys.BranchEnergy]: {
    path: MainRouteKeys.BranchEnergy,
    name: 'Thương hiệu',
    title: 'Thương hiệu',
    element: <BranchEnergyPage />,
    icon: <Icon.Star />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.OIL_MC],
    screenAction: Actions.ManageOilMerchant_ListOilStoreType,
  },
  [MainRouteKeys.SupplierEnergy]: {
    path: MainRouteKeys.SupplierEnergy,
    name: 'Nhà cung cấp',
    title: 'Nhà cung cấp',
    element: <SupplierEnergyPage />,
    icon: <Icon.SupplierIcon />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.OIL_MC],
    screenAction: Actions.ManageOilMerchant_ListOilSupplier,
  },
  [MainRouteKeys.GasStation]: {
    path: MainRouteKeys.GasStation,
    name: 'Điểm kinh doanh',
    title: 'Điểm kinh doanh',
    element: <GasStationPage />,
    icon: <Icon.Storefront />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.OIL_MC],
    screenAction: Actions.ManageOilMerchant_ListOilStore,
  },
  [MainRouteKeys.TransactionEnergy]: {
    path: MainRouteKeys.TransactionEnergy,
    name: 'Giao dịch',
    title: 'Giao dịch',
    element: <TransactionsEnergyListPage />,
    icon: <Icon.TransactionIcon />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.OIL_MC],
    screenAction: Actions.ManageOilMerchant_GetOilStoreTransaction,
  },
  [MainRouteKeys.BidvVirtualAccount]: {
    path: MainRouteKeys.BidvVirtualAccount,
    name: 'Tài khoản ảo BIDV',
    title: 'Quản lý tài khoản ảo BIDV',
    element: <BidvVirtualAccountPage />,
    icon: <Icon.BankBuilding />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    redirectUrl: MainRouteKeys.BidvVirtualAccountInquiry,
    screenAction: [
      Actions.ManageBIDVVAS_InqueryTransaction,
      Actions.ManageBIDVVAS_SyncTransaction,
    ],
  },
  [MainRouteKeys.BidvVirtualAccountInquiry]: {
    path: MainRouteKeys.BidvVirtualAccountInquiry,
    name: 'Tra cứu VA - Có ĐK Thu hộ',
    title: 'Tra cứu VA - Có ĐK Thu hộ',
    element: <BidvVirtualAccountInquiryPage />,
    icon: <Icon.BankBuilding />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: [
      Actions.ManageBIDVVAS_InqueryTransaction,
      Actions.ManageBIDVVAS_SyncTransaction,
    ],
  },
  [MainRouteKeys.BidvTransHistory]: {
    path: MainRouteKeys.BidvTransHistory,
    name: 'Tra cứu Lịch sử GD',
    title: 'Tra cứu Lịch sử GD',
    element: <BidvTransHistoryPage />,
    icon: <Icon.Collection />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: [
      Actions.ManageBIDVTransaction_Inquiry,
      Actions.ManageBIDVTransaction_Sync,
    ],
  },
  [MainRouteKeys.BidvBankTransfer]: {
    path: MainRouteKeys.BidvBankTransfer,
    name: 'Chuyển tiền BIDV',
    title: 'Quản lý Chuyển tiền BIDV',
    element: <BidvBankTransferPage />,
    icon: <Icon.Wallet />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    redirectUrl: MainRouteKeys.BidvBankTransferWhitelist,
    screenAction: [
      Actions.ManageBIDVTransaction_Inquiry,
      Actions.ManageBIDVTransaction_Sync,
      Actions.ManageBIDVBankTransfer_ViewWhitelist,
      Actions.ManageBIDVBankTransfer_UpdateWhitelist,
    ],
  },
  [MainRouteKeys.BidvBankTransferReconciliation]: {
    path: MainRouteKeys.BidvBankTransferReconciliation,
    name: 'Đối soát giao dịch Chuyển tiền',
    title: 'Đối soát giao dịch Chuyển tiền BIDV',
    element: <BidvBankTransferReconciliationPage />,
    icon: <Icon.Collection />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: Actions.ManageBIDVTransaction_Sync,
  },
  [MainRouteKeys.BidvBankTransferWhitelist]: {
    path: MainRouteKeys.BidvBankTransferWhitelist,
    name: 'Whitelist Chuyển tiền',
    title: 'Quản lý Whitelist Chuyển tiền BIDV',
    element: <BidvBankTransferWhitelistPage />,
    icon: <Icon.ManageList />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: [
      Actions.ManageBIDVBankTransfer_ViewWhitelist,
      Actions.ManageBIDVBankTransfer_UpdateWhitelist,
    ],
  },
  [MainRouteKeys.BidvTransferDestWhitelist]: {
    path: MainRouteKeys.BidvTransferDestWhitelist,
    name: 'Whitelist Người nhận',
    title: 'Quản lý Whitelist Người nhận BIDV',
    element: <BidvTransferDestWhitelistPage />,
    icon: <Icon.ManageList />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: [
      Actions.ManageBIDVTransferDestWhitelist_List,
      Actions.ManageBIDVTransferDestWhitelist_Create,
      Actions.ManageBIDVTransferDestWhitelist_Update,
      Actions.ManageBIDVTransferDestWhitelist_Delete,
    ],
  },
  [MainRouteKeys.BidvTransferWithEvidence]: {
    path: MainRouteKeys.BidvTransferWithEvidence,
    name: 'Chuyển tiền kèm chứng từ',
    title: 'Chuyển tiền kèm chứng từ',
    element: <BidvTransferWithEvidencePage />,
    icon: <Icon.Wallet />,
    roles: '*',
    redirectUrl: MainRouteKeys.BidvTransferWithEvidenceCreate,
    screenAction: '',
  },
  [MainRouteKeys.BidvTransferWithEvidenceCreate]: {
    path: MainRouteKeys.BidvTransferWithEvidenceCreate,
    name: 'Tạo yêu cầu chuyển tiền',
    title: 'Tạo yêu cầu Chuyển tiền kèm chứng từ',
    element: <BidvTransferWithEvidenceCreatePage />,
    icon: <Icon.BalanceIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.BidvTransferWithEvidenceOwn]: {
    path: MainRouteKeys.BidvTransferWithEvidenceOwn,
    name: 'Quản lý Y/C chuyển tiền',
    title: 'Yêu cầu chuyển tiền của tôi',
    element: <BidvTransferWithEvidenceOwnPage />,
    icon: <Icon.ManageList />,
    roles: '*',
    screenAction: Actions.ManageTransferWithEvidence_List,
  },
  [MainRouteKeys.BidvTransferWithEvidenceAll]: {
    path: MainRouteKeys.BidvTransferWithEvidenceAll,
    name: 'Duyệt Y/C chuyển tiền',
    title: 'Quản lý tất cả Yêu cầu chuyển tiền',
    element: <BidvTransferWithEvidenceAllPage />,
    icon: <Icon.ManageList />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC],
    screenAction: '',
  },
  [MainRouteKeys.BidvTransferWithEvidenceDetails]: {
    path: MainRouteKeys.BidvTransferWithEvidenceDetails,
    name: 'Chi tiết Y/C chuyển tiền',
    title: 'Chi tiết Yêu cầu chuyển tiền',
    element: <BidvTransferWithEvidenceDetailsPage />,
    icon: <Icon.Data />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.Settings]: {
    path: MainRouteKeys.Settings,
    name: 'Setting',
    title: 'Setting',
    element: <SettingsPage />,
    icon: <Icon.Setting />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    redirectUrl: MainRouteKeys.AppVersionConfig,
    screenAction: [
      Actions.ManageAppVersionConfig_Update,
      Actions.ManageSmsRateLimit_Unlock,
      Actions.ManageBalanceOperationControls_View,
      Actions.ManageBalanceOperationControls_Update,
    ],
  },
  [MainRouteKeys.AppVersionConfig]: {
    path: MainRouteKeys.AppVersionConfig,
    name: 'Version Ứng dụng',
    title: 'Version Ứng dụng',
    element: <AppVersionConfigPage />,
    icon: <Icon.Data />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    screenAction: Actions.ManageAppVersionConfig_Update,
  },
  [MainRouteKeys.UnlockSmsRateLimit]: {
    path: MainRouteKeys.UnlockSmsRateLimit,
    name: 'Unblock SMS Limit',
    title: 'Unblock SMS Limit',
    element: <UnlockSmsRateLimitPage />,
    icon: <Icon.UnlockUserIcon />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    screenAction: Actions.ManageSmsRateLimit_Unlock,
  },
  [MainRouteKeys.BalanceOperationControls]: {
    path: MainRouteKeys.BalanceOperationControls,
    name: 'Cấu hình trừ điểm',
    title: 'Cấu hình trừ điểm',
    element: <BalanceOperationControlsPage />,
    icon: <Icon.Setting />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    screenAction: Actions.ManageBalanceOperationControls_View,
  },
} as MainRouteObject;
